module.exports = __webpack_public_path__ + "static/media/News-02.f0c6f44e.png";